import React from 'react';
import StudySectionIcon from './StudySectionIcon';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { researcherPageSx, researcherContentSx, researcherTitleSx, researcherSectionSx,
  researcherSectionTitleSx, researcherFontFamily, researcherTableContainerSx, researcherTableSx } from './researcherPresentation';

export default function ResearcherTabLayout({ title, icon, children }: {
  title: string; icon: React.ReactNode; children: React.ReactNode;
}) {
  return <Box component="section" aria-label={title} sx={researcherPageSx}>
    <Box sx={researcherContentSx}>
      <Stack direction="row" gap={1} alignItems="center" sx={{ mb: 1.5 }}>
        <StudySectionIcon>{icon}</StudySectionIcon>
        <Typography component="h1" sx={researcherTitleSx}>{title}</Typography>
      </Stack>
      <Paper variant="outlined" sx={{ ...researcherSectionSx,
        '& .MuiTypography-root': { fontFamily: researcherFontFamily },
        '& .MuiTypography-h6': researcherSectionTitleSx,
        '& .MuiButton-root': { borderRadius: '9px', textTransform: 'none' },
        '& .MuiTableContainer-root': researcherTableContainerSx,
        '& .MuiTable-root': researcherTableSx }}>
        {children}
      </Paper>
    </Box>
  </Box>;
}
